import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function SEOArticlesGrid() {
  const displayArticles = articles.slice(1, 10);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-14">
          <p className="text-xs font-medium tracking-widest uppercase text-foreground-400 mb-3">SEO Guides</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            In-Depth PandabuySpreadsheet<br />Shopping Guides
          </h2>
          <p className="mt-4 text-lg text-foreground-500 max-w-2xl">
            Expert-curated guides covering every category, trend, and strategy for getting the most out of your pandabuyspreadsheet experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden hover:border-background-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold mb-3">
                  {article.category}
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-900 leading-snug group-hover:text-foreground-700 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.readTime} read</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>SEO Guide</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/shopping-guide"
            className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 rounded-full text-sm font-semibold text-foreground-700 hover:border-foreground-700 hover:text-foreground-900 transition-all cursor-pointer whitespace-nowrap"
          >
            View All Shopping Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}